import './ErrorPage.css'

function ErrorPage(){
    return(
        <div className="container">
            <p>sorry, path doesn't Exist</p>
        </div>
    )
}

export default ErrorPage;